import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
	Form,
	Button,
	Row,
	Col,
	Card,
	notification,
	Tag,
	Descriptions,
	Space,
	Spin,
	Divider,
	Table,
} from "antd";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import { getFileNameFromPath, downloadFile } from "../../utils/helper";
import { FormOutlined } from "@ant-design/icons";
import csrfService from "../../services/scrf";
import approvalService from "../../services/approver";

import CommentSystem from "../../components/comment";
import CreatedByComponent from "../../components/commonDetails/createdBy";
import ApproversComponent from "../../components/commonDetails/approvers";
import ApproveDisapproveComponent from "./../../components/commonDetails/approveDisapprove/index";
import TaskStatus from "../../components/commonDetails/taskStatus";
import { replaceLineBreaks } from "../../utils/helper";
import FeedbackModal from "../../components/feedbackModal";
import DeploymentModal from "../../components/deploymentModal";
import TaskModal from "../../components/taskModal";

import AddApproversComponent from "../../components/commonDetails/manageApprovers";
import { useSelector } from "react-redux";
import { canManageApprovers } from "../../utils/permissions";
import ViewCustomFields from "../../components/viewCustomFields";

const ScrfDetails = () => {
	const navigate = useNavigate();

	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState(null);
	const [data, setData] = useState([]);
	const { id } = useParams();
	const [assignedUserId, setAssignedUserId] = useState(null);
	const [formId] = useState(2);
	const [specificReturnGroupId, setSpecificReturnGroupId] = useState([]);

	const { currentUser } = useSelector((state) => state.user);
	const hasEditPermission = canManageApprovers(currentUser, "Scrf");
	console.log("hasEditPermission    ", hasEditPermission);
	
	// PRINT STYLES & PRINT HANDLER
	useEffect(() => {
		const style = document.createElement("style");
		style.innerHTML = `
      @media print {
        body * {
          visibility: hidden;
        }
        #qqq{
          display:none;
        }
        #ppp, #ppp * {
          visibility: visible;
        }
        #ppp {
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    `;
		document.head.appendChild(style);
		return () => {
			document.head.removeChild(style);
		};
	}, []);

	const [isPrintable, setIsPrintable] = useState(false);
	const handlePrintClick = () => {
		setIsPrintable(true);
		setTimeout(() => {
			window.print();
			setIsPrintable(false);
		}, 100);
	};

	const deleteFile = async (id) => {
		setLoading(true);
		await csrfService
			.deleteScrfCommentAttachment(id)
			.then((response) => {
				// console.log(response);
				setData(response);
				setLoading(false);
			})
			.catch((error) => {
				navigate("/scrf");
			});
	};

	const getScrfDetails = async () => {
		setLoading(true);
		await csrfService
			.getScrfDetails(id)
			.then((response) => {
				setData(response);
				console.log(response);
				setLoading(false);
			})
			.catch((error) => {
				navigate("/scrf");
			});
	};

	useEffect(() => {
		getScrfDetails();
	}, []);

	const handleSubmit = async (values, isParallel) => {
		setLoading(true);
		const formattedValues = {
			status,
			approved_disapproved: false,
			form_id: formId,
			key: parseInt(id),
			reason: values.message,
			...(isParallel && { assigned_user_id: assignedUserId }),

			...(specificReturnGroupId &&
				Number(specificReturnGroupId) > 0 && {
					approver_id: Number(specificReturnGroupId),
				}),
		};

		console.log("formattedValues", formattedValues);

		const serviceMethod = isParallel
			? approvalService.updateParallelStatus
			: approvalService.updateStatus;

		try {
			const response = await serviceMethod(formattedValues);
			if (response.success) {
				notification.success({
					message: "Status",
					description: response.message,
				});
				form.resetFields();
				getScrfDetails();
			}
			navigate("/dashboard");
		} catch (error) {
			notification.error({
				message: "Error",
				description: error.response?.data?.message || "An error occurred",
			});
		} finally {
			setLoading(false);
		}
	};
	// const handleAnotherModalOk = () => {
	//   console.log('Another modal confirmed!');
	// };

	// const handleAnotherModalCancel = () => {
	//   console.log('Another modal canceled!');
	// };

	// Comment Condition Updated
	let canComment = 0;
	if (data) {
		if (data.status !== "Approved" && data.status !== "Return") {
			canComment = 1;
		} else {
			if (data.comment_status === 1) {
				canComment = 1;
			}
		}
	}
	// Comment Condition Updated
	// console.log("role verification ")
	const Isadmin = currentUser.roles.includes("admin");

	//  For hiding next hierarchy to the user
	let filteredApprovers = [];
	if (data && Array.isArray(data.approvers)) {
		filteredApprovers = data.approvers.map((approver) => ({
			...approver,
			users: approver.users
				? approver.users.filter((user) => user.status === "Processing")
				: [],
		}));
		// console.log("filteredApprovers");
		// console.log(filteredApprovers);
	}
	//  For hiding next hierarchy to the user

	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header icon={<FormOutlined />} title='SCRF Details' />
				</Col>
			</Row>
			<Spin spinning={loading}>
				{data?.task_status?.id !== null && (
					<FeedbackModal
						title='QA Feedback'
						formId={formId}
						assurable_id={id}
						style={{ marginright: "0" }}
					/>
				)}
				{data?.deployments !== null && (
					<DeploymentModal
						title='Deployments'
						data_deployment={data?.deployments}
						style={{ marginright: "0" }}
					/>
				)}
				<TaskModal
					title='Tasks Logs'
					data_tasks={data.assigned_task?.assign_task_teams}
					style={{ marginRight: "0" }}
				/>
				{/* PRINTABLE CARD */}
				{isPrintable && (
					<Card
						style={{
							minHeight: "100vh",
							marginLeft: "-200px",
							marginTop: "-50px",
							border: "none",
							padding: 24,
							background: "#fff",
						}}
						id='ppp'
					>
						<Row gutter={[24, 24]}>
							<Col span={4} style={{ textAlign: "center" }}>
								<img
									src={
										currentUser?.company?.logo
											? currentUser.company.logo.replace("/uploads", "")
											: "https://www.lucky-cement.com/wp-content/uploads/2017/02/lucky-logo.png"
									}
									alt='Logo'
									style={{ height: "40px", width: "auto", marginBottom: 16 }}
								/>
							</Col>
							<Col span={16} style={{ textAlign: "center" }}>
								<h2 style={{ marginBottom: 0 }}>
									<strong>SCRF Request Details</strong>
								</h2>
							</Col>
							<Col span={4} style={{ textAlign: "center" }}>
								<h3> Internal </h3>
							</Col>
						</Row>
						<Row gutter={[24, 24]}>
							<Col span={24} style={{ textAlign: "center" }}>
								<div style={{ fontSize: 12, marginBottom: 16 }}>
									<b>Sequence No:</b> {data.sequence_no} &nbsp; | &nbsp;
									<b>Request Title:</b> {data.request_title} &nbsp; | &nbsp;
									<b>Status:</b> {data.status}
								</div>
							</Col>
						</Row>
						<Divider />
						<Row gutter={[16, 16]}>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>Change Type:</b> <Tag>{data.change_type}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>Change Priority:</b> <Tag>{data.change_priority}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>Change Significance:</b>{" "}
								<Tag>{data.change_significance}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>Task Status:</b> <Tag>{data.task_status?.name}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>Location:</b> <Tag>{data.location?.name}</Tag>
							</Col>
						</Row>
						<Divider />
						<Row gutter={[16, 16]}>
							<Col span={24}>
								<b>Request Specs & Business Justification:</b>
								<div
									style={{ marginTop: 8 }}
									dangerouslySetInnerHTML={{
										__html: replaceLineBreaks(data.request_specs),
									}}
								/>
							</Col>
						</Row>
						<Divider />
						{data && data.attachments && (
							<Row gutter={[16, 16]}>
								<Col span={24}>
									<b>Attachments:</b>
									<table
										style={{
											width: "100%",
											borderCollapse: "collapse",
											marginTop: 8,
										}}
									>
										<thead>
											<tr>
												<th
													style={{
														textAlign: "left",
														padding: 8,
														borderBottom: "1px solid #eee",
													}}
												>
													Title
												</th>
												<th
													style={{
														textAlign: "left",
														padding: 8,
														borderBottom: "1px solid #eee",
													}}
												>
													Preview
												</th>
											</tr>
										</thead>
										<tbody>
											{data.attachments.map((attachment) => {
												const isImage = (filename) =>
													/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
												const fileUrl = attachment.filename;
												const fileTitle =
													attachment.original_title || attachment.filename;
												return (
													<tr key={attachment.id}>
														<td style={{ padding: 8 }}>{fileTitle}</td>
														<td style={{ padding: 8 }}>
															{isImage(fileUrl) ? (
																<img
																	src={fileUrl}
																	alt={fileTitle}
																	style={{
																		width: 40,
																		height: 40,
																		objectFit: "cover",
																		borderRadius: 4,
																		border: "1px solid #eee",
																	}}
																/>
															) : (
																<span style={{ color: "#aaa", fontSize: 12 }}>
																	No preview
																</span>
															)}
														</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</Col>
							</Row>
						)}
						<Divider />
						<Row gutter={[16, 16]}>
							<Col span={24}>
								<b>Additional Information:</b>
								<Row gutter={[16, 16]} style={{ marginTop: 8 }}>
									<Col xs={24} sm={12} md={8} lg={6} xl={6}>
										<b>Man Hours Saving:</b> <Tag>{data.man_hours || 0}</Tag>
									</Col>
									<Col xs={24} sm={12} md={8} lg={6} xl={6}>
										<b>Other Benefits:</b>{" "}
										<span
											dangerouslySetInnerHTML={{
												__html: replaceLineBreaks(data.other_benefits),
											}}
										/>
									</Col>
									<Col xs={24} sm={12} md={8} lg={6} xl={6}>
										<b>Cost Saved:</b>{" "}
										<span
											dangerouslySetInnerHTML={{
												__html: replaceLineBreaks(data.cost_saved || ""),
											}}
										/>
									</Col>
									<Col xs={24} sm={12} md={8} lg={6} xl={6}>
										<b>Controls Improved:</b>{" "}
										<span
											dangerouslySetInnerHTML={{
												__html: replaceLineBreaks(data.controls_improved || ""),
											}}
										/>
									</Col>
									<Col xs={24} sm={12} md={8} lg={6} xl={6}>
										<b>Legal Reasons:</b>{" "}
										<span
											dangerouslySetInnerHTML={{
												__html: replaceLineBreaks(data.legal_reasons || ""),
											}}
										/>
									</Col>
									{data.process_efficiency && (
										<Col xs={24} sm={12} md={8} lg={6} xl={6}>
											<b>Business Process Change:</b>{" "}
											<span
												dangerouslySetInnerHTML={{
													__html: replaceLineBreaks(data.process_efficiency),
												}}
											/>
										</Col>
									)}
								</Row>
							</Col>
						</Row>
						<Divider />
						<Card
							title={<span style={{ fontSize: "14px" }}>Created By</span>}
							className=''
							// style={{ border: "none"}}
							style={{
								border: "none",
								pageBreakBefore: "always",
								margin: "-10px",
							}}
						>
							{data && data.created_by && (
								<>
									<Row gutter={[8, 8]} className=''>
										<Col xs={24} sm={8} md={8} lg={8} xl={8}>
											<span className='fs-10 '>
												<strong>Created At</strong>&nbsp;
											</span>
											<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
												&nbsp;{data.created_at}{" "}
											</Tag>
										</Col>

										<Col xs={24} sm={8} md={8} lg={8} xl={8}>
											<span className='fs-10 '>
												<strong>Name</strong>&nbsp;
											</span>
											<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
												&nbsp;{data.created_by.name}{" "}
											</Tag>
										</Col>

										<Col xs={24} sm={8} md={8} lg={8} xl={8}>
											<span className='fs-10 '>
												<strong>Department:</strong>&nbsp;
											</span>
											<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
												&nbsp;{data.department.name}{" "}
											</Tag>
										</Col>
									</Row>
								</>
							)}
						</Card>
						<Card
							title={
								<span
									style={{
										fontSize: "14px",
										display: "block",
										textAlign: "center",
									}}
								>
									Approvers
								</span>
							}
							className=''
							style={{
								border: "none",
							}}
						>
							<Row gutter={[16, 16]}>
								<Col span={24}>
									<div style={{ overflowX: "auto", marginTop: 8 }}>
										<table
											style={{
												width: "100%",
												borderCollapse: "collapse",
												fontSize: 13,
											}}
										>
											<thead>
												<tr style={{ background: "#f5f5f5" }}>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Group
													</th>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Name
													</th>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Status
													</th>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Action Performed At
													</th>
												</tr>
											</thead>
											<tbody>
												{Array.isArray(data?.approvers) &&
												data.approvers.length > 0 ? (
													data.approvers.flatMap((group) => {
														const respondedUsers = Array.isArray(group.users)
															? group.users.filter(
																	(approver) =>
																		approver.responded_by &&
																		approver.id &&
																		approver.responded_by.id === approver.id,
																)
															: [];

														if (respondedUsers.length === 0) {
															return [];
														}

														return respondedUsers.map((approver, uidx) => (
															<tr key={`${group.id}-${approver.id || uidx}`}>
																{uidx === 0 && (
																	<td
																		rowSpan={respondedUsers.length}
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																			fontWeight: "bold",
																			background: "#fafafa",
																			verticalAlign: "top",
																		}}
																	>
																		{group.name || "-"}
																	</td>
																)}
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.name || "-"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.status || "-"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.status_at || "-"}
																</td>
															</tr>
														));
													})
												) : (
													<tr>
														<td
															colSpan={4}
															style={{ padding: 8, textAlign: "center" }}
														>
															No approvers found.
														</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								</Col>
							</Row>
						</Card>
						<Divider />
						{data &&
							data.quality_assurances &&
							data.quality_assurances.length > 0 && (
								<>
									<Divider />
									<Card
										title={
											<span
												style={{
													fontSize: "14px",
													display: "block",
													textAlign: "center",
												}}
											>
												Quality Assurance Details
											</span>
										}
										className=''
										style={{
											border: "none",
										}}
									>
										<Row gutter={[16, 16]}>
											<Col span={24}>
												<div style={{ overflowX: "auto", marginTop: 8 }}>
													<table
														style={{
															width: "100%",
															borderCollapse: "collapse",
															fontSize: 13,
														}}
													>
														<thead>
															<tr style={{ background: "#f5f5f5" }}>
																<th
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	QA User
																</th>
																<th
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	Status
																</th>
																<th
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	Testing Type
																</th>
																<th
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	Status At
																</th>
																<th
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	Feedback
																</th>
															</tr>
														</thead>
														<tbody>
															{data.quality_assurances.map((qa) => (
																<tr key={qa.id}>
																	<td
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																		}}
																	>
																		{qa.qa_user?.name || "Unassigned"}
																	</td>
																	<td
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																		}}
																	>
																		{qa.status ? (
																			<Tag
																				color={
																					qa.status === "Modification Required"
																						? "orange"
																						: "green"
																				}
																			>
																				{qa.status}
																			</Tag>
																		) : (
																			<Tag>Pending</Tag>
																		)}
																	</td>
																	<td
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																		}}
																	>
																		{qa.testing_type || "-"}
																	</td>
																	<td
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																		}}
																	>
																		{qa.status_at || "-"}
																	</td>
																	<td
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																		}}
																	>
																		{qa.feedback ? (
																			<div
																				dangerouslySetInnerHTML={{
																					__html: replaceLineBreaks(
																						qa.feedback,
																					),
																				}}
																			/>
																		) : (
																			"-"
																		)}
																	</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</Col>
										</Row>
									</Card>
								</>
							)}
						<Divider />
						{data && data.deployments && data.deployments.length > 0 && (
							<>
								<Card
									title={
										<span
											style={{
												fontSize: "14px",
												display: "block",
												textAlign: "center",
											}}
										>
											Deployment Details
										</span>
									}
									className=''
									style={{
										border: "none",
									}}
								>
									<Row gutter={[16, 16]}>
										<Col span={24}>
											<div style={{ overflowX: "auto", marginTop: 8 }}>
												<table
													style={{
														width: "100%",
														borderCollapse: "collapse",
														fontSize: 13,
													}}
												>
													<thead>
														<tr style={{ background: "#f5f5f5" }}>
															<th
																style={{ padding: 8, border: "1px solid #eee" }}
															>
																Deployment No
															</th>
															<th
																style={{ padding: 8, border: "1px solid #eee" }}
															>
																Created By
															</th>
															<th
																style={{ padding: 8, border: "1px solid #eee" }}
															>
																Created At
															</th>
															<th
																style={{ padding: 8, border: "1px solid #eee" }}
															>
																Document No
															</th>
															<th
																style={{ padding: 8, border: "1px solid #eee" }}
															>
																Details
															</th>
														</tr>
													</thead>
													<tbody>
														{data.deployments.map((deployment) => (
															<React.Fragment key={deployment.id}>
																{deployment.deployment_details.map(
																	(detail, index) => (
																		<tr key={`${deployment.id}-${detail.id}`}>
																			{index === 0 && (
																				<>
																					<td
																						rowSpan={
																							deployment.deployment_details
																								.length
																						}
																						style={{
																							padding: 8,
																							border: "1px solid #eee",
																							fontWeight: "bold",
																							background: "#fafafa",
																							verticalAlign: "top",
																						}}
																					>
																						{deployment.sequence_no}
																					</td>
																					<td
																						rowSpan={
																							deployment.deployment_details
																								.length
																						}
																						style={{
																							padding: 8,
																							border: "1px solid #eee",
																							verticalAlign: "top",
																						}}
																					>
																						{deployment.created_by.name}
																					</td>
																					<td
																						rowSpan={
																							deployment.deployment_details
																								.length
																						}
																						style={{
																							padding: 8,
																							border: "1px solid #eee",
																							verticalAlign: "top",
																						}}
																					>
																						{deployment.created_at}
																					</td>
																				</>
																			)}
																			<td
																				style={{
																					padding: 8,
																					border: "1px solid #eee",
																				}}
																			>
																				{detail.document_no}
																			</td>
																			<td
																				style={{
																					padding: 8,
																					border: "1px solid #eee",
																				}}
																			>
																				{detail.detail}
																			</td>
																		</tr>
																	),
																)}
															</React.Fragment>
														))}
													</tbody>
												</table>
											</div>
										</Col>
									</Row>
								</Card>
							</>
						)}
						<Divider />
						<Row gutter={[16, 16]}>
							<Col span={24} style={{ fontSize: 12, marginTop: 16 }}>
								This document has been approved through the system-based
								workflow.
								<br />
								Detailed information for SCRF ID: {id} can be accessed from this
								link.{" "}
								<a
									href={window.location.href}
									target='_blank'
									rel='noopener noreferrer'
								>
									View Details
								</a>
							</Col>
						</Row>
					</Card>
				)}

				{/* WEB PAGE CARD */}
				<Card style={{ minHeight: "100vh" }} id='qqq'>
					{/* ...existing code... */}
					<Row gutter={[24, 24]}>
						<Col lg={5} md={5} sm={7} xs={7}>
							<CreatedByComponent data={data} />
							<Button
								type='primary'
								onClick={handlePrintClick}
								style={{
									marginTop: "20px",
									marginBottom: "20px",
									width: "100%",
								}}
							>
								Print Document
							</Button>
							{data &&
								(data.status === "Pending" || data.status === "Approved") &&
								hasEditPermission && (
									<AddApproversComponent data={data} formId={formId} />
								)}
							{/* <ApproversComponent approvers={filteredApprovers} /> */}
							<ApproversComponent
								approvers={Array.isArray(data?.approvers) ? data.approvers : []}
							/>
						</Col>
						<Col lg={19} md={19} sm={17} xs={17}>
							<div>
								{data?.approved_disapproved === true && (
									<div
										style={{
											position: "static",
											top: 1,
											zIndex: 999,
											background: "#fff",
											padding: "5px",
											borderRadius: "4px",
										}}
									>
										<Spin spinning={loading}>
											<b>Approval Request</b>
											<ApproveDisapproveComponent
												form={form}
												handleStatus={(values) => handleSubmit(values, false)}
												loading={loading}
												setStatus={setStatus}
												dataRecord={data}
												setSpecificReturnGroupId={setSpecificReturnGroupId}
											/>
										</Spin>
									</div>
								)}

								{data?.parallel_approved_disapproved === true && (
									<div
										style={{
											position: "static",
											top: data?.approved_disapproved ? "150px" : "1px",
											zIndex: 999,
											background: "#fff", // Add a background color
											padding: "5px", // Add padding for better visual separation
											borderRadius: "4px", // Optional: Add rounded corners
										}}
									>
										<Spin spinning={loading}>
											<b>Parallel Approval Request</b>
											<ApproveDisapproveComponent
												form={form}
												handleStatus={(values) => handleSubmit(values, true)}
												loading={loading}
												setStatus={setStatus}
												parallel={true}
												parallelUsers={
													data && data.parallel_approved_disapproved_users
												}
												setAssignedUserId={setAssignedUserId}
												reloadData={getScrfDetails}
												dataRecord={data}
												setSpecificReturnGroupId={setSpecificReturnGroupId}
											/>
										</Spin>
									</div>
								)}

								{data?.assigned_task_to_me === true && (
									<div
										style={{
											position: "sticky",
											top: "1px",
											zIndex: 999,
											background: "#fff", // Add a background color
											padding: "5px", // Add padding for better visual separation
											borderRadius: "4px", // Optional: Add rounded corners
										}}
									>
										<TaskStatus
											data={data}
											reloadData={getScrfDetails}
											formId={formId}
										/>
									</div>
								)}

								{data && data.request_title && (
									<>
										<Card title='Basic Information' className='mb-10'>
											<Row gutter={[16, 16]}>
												<Col xs={24} sm={12} md={8} lg={3} xl={3}>
													<p className='fs-12 mb-10 bold'>Sequence No</p>
													<Tag>{data.sequence_no}</Tag>
												</Col>

												<Col xs={24} sm={12} md={8} lg={8} xl={8} flex='none'>
													<p className='fs-12 mb-10 bold'>Request Title</p>
													<Tag>{data.request_title}</Tag>
												</Col>

												<Col xs={24} sm={12} md={8} lg={6} xl={6} flex='none'>
													<p className='fs-12 mb-10 bold'>Change Type</p>
													<Tag>{data.change_type}</Tag>
												</Col>

												<Col xs={12} sm={12} md={8} lg={3} xl={3} flex='none'>
													<p className='fs-12 mb-10 bold'>Change Priority</p>
													<Tag>{data.change_priority}</Tag>
												</Col>

												<Col xs={12} sm={12} md={8} lg={4} xl={4} flex='none'>
													<p className='fs-12 mb-10 bold'>
														Change Significance
													</p>
													<Tag>{data.change_significance}</Tag>
												</Col>

												<Col xs={12} sm={12} md={8} lg={6} xl={6} flex='none'>
													<p className='fs-12 mb-10 bold'>Task Status</p>
													<Tag>{data.task_status?.name}</Tag>
												</Col>

												<Col xs={12} sm={12} md={8} lg={6} xl={6} flex='none'>
													<p className='fs-12 mb-10 bold'>Location</p>
													<Tag>{data.location?.name}</Tag>
												</Col>

												{data && data.assigned_task?.start_at && (
													<Col xs={12} sm={12} md={8} lg={6} xl={6}>
														<p className='fs-12 mb-10 bold'>Start Date</p>
														<Tag>{data.assigned_task?.start_at}</Tag>
													</Col>
												)}
												{data && data.assigned_task?.due_at && (
													<Col xs={12} sm={12} md={8} lg={5} xl={5}>
														<p className='fs-12 mb-10 bold'>Deadline</p>
														<Tag>{data.assigned_task?.due_at}</Tag>
													</Col>
												)}
											</Row>
										</Card>
										{data && data.created_at && (
											<Card
												title='Request Specs & Business Justification'
												className='mb-10'
											>
												<Descriptions>
													<Descriptions.Item>
														<div
															style={{ fontSize: 14 }}
															dangerouslySetInnerHTML={{
																__html: replaceLineBreaks(data.request_specs),
															}}
														/>
													</Descriptions.Item>
												</Descriptions>
											</Card>
										)}
										{data && data.attachments && (
											<Card title='Attachments' className='mb-10'>
												<table
													style={{ width: "100%", borderCollapse: "collapse" }}
												>
													<thead>
														<tr>
															<th
																style={{
																	textAlign: "left",
																	padding: 8,
																	borderBottom: "1px solid #eee",
																}}
															>
																Title
															</th>
															<th
																style={{
																	textAlign: "left",
																	padding: 8,
																	borderBottom: "1px solid #eee",
																}}
															>
																Preview
															</th>
															<th
																style={{
																	textAlign: "left",
																	padding: 8,
																	borderBottom: "1px solid #eee",
																}}
															>
																Action
															</th>
														</tr>
													</thead>
													<tbody>
														{data.attachments.map((attachment) => {
															const isImage = (filename) =>
																/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
																	filename,
																);
															const fileUrl = attachment.filename;
															const fileTitle =
																getFileNameFromPath(
																	attachment.original_title,
																) || getFileNameFromPath(attachment.filename);
															return (
																<tr key={attachment.id}>
																	<td
																		style={{
																			padding: 8,
																			verticalAlign: "middle",
																		}}
																	>
																		{fileTitle}
																	</td>
																	<td
																		style={{
																			padding: 8,
																			verticalAlign: "middle",
																		}}
																	>
																		{isImage(fileUrl) ? (
																			<a
																				href={fileUrl}
																				target='_blank'
																				rel='noopener noreferrer'
																				title='Preview image'
																			>
																				<img
																					src={fileUrl}
																					alt={fileTitle}
																					style={{
																						width: 40,
																						height: 40,
																						objectFit: "cover",
																						borderRadius: 4,
																						border: "1px solid #eee",
																						boxShadow:
																							"0 1px 4px rgba(0,0,0,0.08)",
																					}}
																				/>
																			</a>
																		) : (
																			<span
																				style={{ color: "#aaa", fontSize: 12 }}
																			>
																				No preview
																			</span>
																		)}
																	</td>
																	<td
																		style={{
																			padding: 8,
																			verticalAlign: "middle",
																		}}
																	>
																		<Button
																			size='small'
																			className='mb-10'
																			type='primary'
																			onClick={() => downloadFile(fileUrl)}
																		>
																			Download
																		</Button>
																	</td>
																</tr>
															);
														})}
													</tbody>
												</table>
											</Card>
										)}
										{data &&
											data.software_category &&
											data.software_category && (
												<Card title='Software Information' className='mb-10'>
													<Descriptions>
														<Descriptions.Item label='Software Category'>
															<Tag>{data.software_category.name}</Tag>
														</Descriptions.Item>
													</Descriptions>
													<span
														style={{
															marginLeft: "3px",
															color: "rgba(0, 0, 0, 0.45)",
														}}
													>
														{" "}
														Sub-Category:{" "}
													</span>{" "}
													{data.software_subcategories.map(
														(subcategory, index) => (
															<Tag className='mb-10' key={index}>
																{subcategory.name}{" "}
															</Tag>
														),
													)}
												</Card>
											)}
										{data && data.uatScenarios && (
											<Card title='UAT Scenarios' className='mb-10'>
												{data.uatScenarios.map((scenario) => (
													<div key={scenario.id}>
														<Row gutter={[16, 16]} className='mt-20'>
															<Col xs={24} sm={12} md={8} lg={6} xl={6}>
																<p className='fs-12 mb-10 bold'>
																	Scenario Details:{" "}
																</p>
																<Tag>{scenario.detail}</Tag>
															</Col>
															<Col xs={24} sm={12} md={8} lg={6} xl={6}>
																<p className='fs-12 mb-10 bold'>
																	Scenario Status:{" "}
																</p>
																<Tag>{scenario.status}</Tag>
															</Col>
														</Row>
													</div>
												))}
											</Card>
										)}
										<Card title='Additional Information' className='mb-10'>
											<Row>
												<Col
													xs={24}
													sm={12}
													md={12}
													lg={12}
													xl={12}
													className='mb-20'
												>
													<p className='fs-12 mb-10 bold'>Man Hours Saving</p>
													{data.man_hours ? <Tag>{data.man_hours}</Tag> : "0"}
												</Col>

												<Col xs={24} sm={12} md={12} lg={12} xl={12}>
													<p className='fs-12 mb-10 bold'>Other Benefits</p>
													{data.other_benefits ? (
														<div
															dangerouslySetInnerHTML={{
																__html: replaceLineBreaks(data.other_benefits),
															}}
														/>
													) : (
														"-"
													)}
												</Col>

												<Col xs={24} sm={12} md={12} lg={12} xl={12}>
													<p className='fs-12 mb-10 bold'>Cost Saved</p>
													{data.cost_saved ? (
														<div
															dangerouslySetInnerHTML={{
																__html: replaceLineBreaks(data.cost_saved),
															}}
														/>
													) : (
														"-"
													)}
												</Col>
												<Col xs={24} sm={12} md={12} lg={12} xl={12}>
													<p className='fs-12 mb-10 bold'>Controls Improved</p>
													{data.controls_improved ? (
														<div
															dangerouslySetInnerHTML={{
																__html: replaceLineBreaks(
																	data.controls_improved,
																),
															}}
														/>
													) : (
														"-"
													)}
												</Col>
												<Col
													xs={24}
													sm={12}
													md={12}
													lg={12}
													xl={12}
													className='mt-20'
												>
													<p className='fs-12 mb-10 bold'>Legal Reasons</p>
													{data.legal_reasons ? (
														<div
															dangerouslySetInnerHTML={{
																__html: replaceLineBreaks(data.legal_reasons),
															}}
														/>
													) : (
														"-"
													)}
												</Col>
												{data.process_efficiency && (
													<Col xs={24} sm={12} md={12} lg={12} xl={12}>
														<p className='fs-12 mb-10 bold'>
															Business Process Change
														</p>
														<div
															dangerouslySetInnerHTML={{
																__html: replaceLineBreaks(
																	data.process_efficiency,
																),
															}}
														/>
													</Col>
												)}
											</Row>
										</Card>

										{/* FETCH DATA CUSTOM FIELDS */}
										<ViewCustomFields customFields={data?.custom_fields} />
									</>
								)}
							</div>

							<CommentSystem
								id={id}
								form_id={formId}
								status={data.status}
								comment_status={canComment}
							/>
						</Col>
					</Row>
				</Card>
			</Spin>
		</DefaultLayout>
	);
};

export default ScrfDetails;
